import React from 'react';
import { Box, Typography } from '@mui/material';

const listItemStyle = {
    marginBottom: '0.75rem',
};


const ProfileSection = () => {
  return (
    <Box sx={{ px: { xs: 2, sm: 4 }, py: 2 }}>
      <Typography paragraph>
        The Profile Page enables users to manage personal details and address-related information in one place.
      </Typography>

      {/* Personal Details Section */}
      <Typography variant="h5" gutterBottom sx={{ mt: 4 }}>
        Personal Details Section
      </Typography>
      <ul style={{ paddingLeft: '1.25rem' }}>
        <li style={listItemStyle}>
          <Typography variant="body1">
            Displays name, email address, and phone number.
          </Typography>
        </li>
        <li style={listItemStyle}>
          <Typography variant="body1">
            Includes an Edit button to modify your details.
          </Typography>
        </li>
      </ul>

      {/* Address Form Section */}
      <Typography variant="h5" gutterBottom sx={{ mt: 4 }}>
        Address Form Section
      </Typography>
      <ul style={{ paddingLeft: '1.25rem' }}>
        <li style={listItemStyle}>
          <Typography variant="body1">
            Allows users to add or update address information, including GST number, street address, city, state, and postal code.
          </Typography>
        </li>
        <li style={listItemStyle}>
          <Typography variant="body1">
            Includes a "Update Address" button to save the updated information.
          </Typography>
        </li>
      </ul>

      {/* User Flow */}
      <Typography variant="h5" gutterBottom sx={{ mt: 4 }}>
        User Flow
      </Typography>
      <ul style={{ paddingLeft: '1.25rem' }}>
        <li style={listItemStyle}>
          <Typography variant="body1">
            Click the "Edit Personal Details" button to change personal information.
          </Typography>
        </li>
        <li style={listItemStyle}>
          <Typography variant="body1">
            Update address using the address form and click "Update Address" button to save the changes.
          </Typography>
        </li>
      </ul>
    </Box>
  );
};

export default ProfileSection;
